import {
  getMessagesByOrder,
  createMessageByOrder,
} from '@homeservices/api-kit/workorder/messages/v1';
import _uniq from 'lodash/uniq';
import { createMessage } from '@/transformations/message';

const DEFAULT_JOB = {
  total: 0,
  loading: false,
  messageIds: [],
};

export default {
  state () {
    return {
      messages: {},
      jobs: {},
    };
  },
  getters: {
    getInfo: (state, getters) => (jobId, skillsProfileId) => {
      return {
        messages: getters.getMessages(jobId, skillsProfileId),
        total: getters.getTotal(jobId, skillsProfileId),
        hasMore: getters.getHasMore(jobId, skillsProfileId),
        loading: getters.getLoading(jobId, skillsProfileId),
        loadingMore: getters.getLoadingMore(jobId, skillsProfileId),
      };
    },
    getMessages: state => (jobId, skillsProfileId) => {
      const job = state.jobs[`${jobId}-${skillsProfileId}`];
      if (!job) { return []; }

      return job.messageIds.map(id => state.messages[id]);
    },
    getTotal: state => (jobId, skillsProfileId) => {
      const job = state.jobs[`${jobId}-${skillsProfileId}`];
      if (!job) { return 0; }

      return job.total;
    },
    getHasMore: state => (jobId, skillsProfileId) => {
      const job = state.jobs[`${jobId}-${skillsProfileId}`];
      if (!job) { return false; }

      return job.total > job.messageIds.length;
    },
    getLoading: state => (jobId, skillsProfileId) => {
      const job = state.jobs[`${jobId}-${skillsProfileId}`];
      if (!job) { return false; }

      return Boolean(job.loading);
    },
    getLoadingMore: (state, getters) => (jobId, skillsProfileId) => {
      const isLoading = getters.getLoading(jobId, skillsProfileId);
      const hasMessages = Boolean(getters.getMessages(jobId, skillsProfileId).length);
      return isLoading && hasMessages;
    },
  },
  actions: {
    async fetchMessages ({ commit }, { jobId, skillsProfileId, ...params }) {
      commit('setLoading', { jobId, skillsProfileId, value: true });
      const { data } = await getMessagesByOrder({
        order_hash: jobId,
        service_provider_id: skillsProfileId,
        ...params,
      });

      commit('addMessages', { jobId, skillsProfileId, data });
      commit('setLoading', { jobId, skillsProfileId, value: false });
    },
    async sendMessage ({ dispatch }, { jobId, service_provider_id, ...params }) {
      await createMessageByOrder(jobId, {
        service_provider_id,
        ...params,
      });
      await dispatch('fetchMessages', { jobId, skillsProfileId: service_provider_id });
    },
    async loadMore ({ dispatch, getters }, { jobId, skillsProfileId, ...params }) {
      if (getters.getHasMore(jobId, skillsProfileId)) {
        const from = getters.getMessages(jobId, skillsProfileId).length;
        // TODO - MESSAGES, load more is not working (did not work before either, existing)
        await dispatch('fetchMessages', { jobId, from, skillsProfileId, ...params });
      }
    },
  },
  mutations: {
    addMessages (state, { jobId, skillsProfileId, data }) {
      const key = `${jobId}-${skillsProfileId}`;
      const job = state.jobs[key] || DEFAULT_JOB;
      const newIds = data.results.map(message => message.message_id);

      // Add new messages to messages object
      state.messages = data.results.reduce((acc, next) => (
        {
          ...acc,
          [next.message_id]: createMessage(next),
        }
      ), state.messages);

      // Attach ids of the messages to the job
      state.jobs = {
        ...state.jobs,
        [key]: {
          ...job,
          total: data.total,
          messageIds: _uniq([...newIds, ...job.messageIds]),
        },
      };
    },
    setLoading (state, { jobId, skillsProfileId, value }) {
      const key = `${jobId}-${skillsProfileId}`;
      const job = state.jobs[key] || DEFAULT_JOB;
      state.jobs = {
        ...state.jobs,
        [key]: {
          ...job,
          loading: value,
        },
      };
    },
  },
};
